import { useArcadeStoreSKUsForCountry } from '@hooks/useArcadeStore';
import { buttonVariants, Skeleton, Text, VStack } from 'ui_2';
import { ArcadeStoreProduct } from './ArcadeStoreProduct';
import { useSettings } from '@src/data/settings';
import { countries } from 'countries-list';
import { BiLinkExternal } from 'react-icons/bi';

export const ArcadeStoreProductsForCountry = () => {
  const {
    data: _data,
    error,
    isError,
    isLoading,
  } = useArcadeStoreSKUsForCountry();

  const { countryCode } = useSettings();

  const data = _data?.filter((product) => product.stock > 0);

  if (isError) {
    return (
      <VStack className='w-full items-center'>
        <Text>
          Error loading product data
          {countryCode &&
            countryCode !== 'global' &&
            ` for ${countries[countryCode].name}`}
          .
        </Text>
        {error && <Text>{error.message}</Text>}
      </VStack>
    );
  } else if (isLoading) {
    return (
      <div className='grid grid-cols-2 gap-8 sm:grid-cols-3'>
        {[...Array(6).keys()].map((_, ix) => (
          <Skeleton
            className='h-[211px] w-full md:h-[246px] md:max-w-[200px] lg:h-[291px] lg:max-w-[250px]'
            delay={ix}
            key={ix}
          />
        ))}
      </div>
    );
  } else if (data?.length === 0) {
    return (
      <VStack className='w-full items-center gap-4'>
        <Text className='max-w-[400px] text-center'>
          No in-stock items
          {countryCode === 'global' || countryCode === undefined
            ? ''
            : ` in ${countries[countryCode].name}`}{' '}
          at the moment. Earn up to $100/month for stocking the arcade store.
          Join our discord if you’re interested in becoming an arcade architect!
        </Text>
        <a
          className={buttonVariants({ className: 'items-center gap-2' })}
          href='https://discord.gg/puzzlearcade'
          target='_blank'
        >
          Join Puzzle Arcade Discord
          <BiLinkExternal />
        </a>
      </VStack>
    );
  } else {
    return (
      <div className='grid grid-cols-2 gap-8 pb-8 sm:grid-cols-3'>
        {data?.map((sku, ix) => (
          <ArcadeStoreProduct sku={sku} service={sku.service} key={ix} />
        ))}
      </div>
    );
  }
};
